import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tshirtDetails: [],
  excelInfo: null,
  designStoreJson: "",
};

const variationSlice = createSlice({
  name: "variation",
  initialState,
  reducers: {
    setTshirtDetails: (state, action) => {
      state.tshirtDetails = action.payload;
    },

    setTShirtInfo: (state, action) => {
      const findIndex = state.tshirtDetails.findIndex(item => parseInt(item.indexSr) === parseInt(action.payload.indexSr)); 
      if(findIndex !== -1){
        state.tshirtDetails[findIndex] = action.payload;
      }
      else{
        state.tshirtDetails.push(action.payload);
      }
    },

    addTshirtRow: (state, action) => {
      state.tshirtDetails.push(action.payload);
    },
    removeTshirtRow: (state, action) => {
      state.tshirtDetails = state.tshirtDetails.filter(
        (_, i) => i !== action.payload
      );
    },
    setExcelInfo: (state, action) => {
      state.excelInfo = action.payload;
    },
    resetExcelInfo : (state) => {
      state.tshirtDetails = []
    },
    setDesignStore: (state, action) => {

      // const jsonVal = JSON.stringify(action.payload)
      state.designStoreJson = action.payload;
    },
  },
});

export const {
  setDesignStore,
  setTshirtDetails,
  addTshirtRow,
  removeTshirtRow,
  setExcelInfo,
  setTShirtInfo,
  resetExcelInfo
} = variationSlice.actions;

export default variationSlice.reducer;
